import { isShopifyOrTest } from '@/utils/platform';

export const isProductPage = (): boolean => {
  const href: string = window.location.href;
  if (isShopifyOrTest()) {
    return href.includes('/products/');
  }
  return false;
};
